import TourListingPage from "../components/tours/TourListingPage";

export default function DashboardPage() {
  return (
    <TourListingPage
      endpoint="tours"
      title="Welcome to Trust Bitcoin Travel Dashboard"
      description="Track your travel rewards, upcoming tours, completed journeys, and verification status — all in one place."
      icon="fa-plane-departure"
    />
  );
}
